import { useCustomerReduced } from '@/core/domain/people/Customers/Customers.hooks';
import { CustomerReduced } from '@/core/domain/people/Customers/Customers.types';
import { useDisclosure } from '@/hooks';
import { Form, InputProps } from 'antd';
import { useEffect } from 'react';
import CustomersSelectedModal from '../CustomersSelectedModal';
import InputSearch from '../InputSearch';

type Props = InputProps & {
  onCustomerSelect: (customer: CustomerReduced) => void;
  fieldNameId: string;
  buttonSearchDisabled?: boolean;
};

const CustomerInputSearch: React.FC<Props> = ({
  onCustomerSelect,
  fieldNameId,
  buttonSearchDisabled = false,
  ...props
}) => {
  const [modalOpened, modalAction] = useDisclosure();
  const form = Form.useFormInstance();
  const customerId = Form.useWatch(fieldNameId, form);

  const { mutateAsync: getCustomer, isLoading } = useCustomerReduced();

  useEffect(() => {
    if (customerId) {
      getCustomer(customerId).then((customer) =>
        form.setFieldValue('customerName', customer.name),
      );
    }
  }, [customerId]);

  return (
    <>
      <InputSearch
        {...props}
        inputProps={{ disabled: true }}
        buttonProps={{
          onClick: modalAction.open,
          loading: isLoading,
          disabled: buttonSearchDisabled,
        }}
      />

      <CustomersSelectedModal
        handleVisible={modalAction.close}
        visible={modalOpened}
        onCustomerSelect={(customer) => {
          onCustomerSelect(customer);
          modalAction.close();
        }}
        noSelection
      />
    </>
  );
};

export default CustomerInputSearch;
